// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ApiOpenWrapper__wrapper___3PS1F"};